import {
  createFileRoute,
  Outlet,
  useChildMatches,
} from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import Loading from "../../../../../components/shared/Loading";
import PageContainer from "../../../../../components/template/PageContainer";
import { validateAdminParams } from "../../../../../router/admin-validation";
import { requireRoles } from "../../../../../router/auth";
import type { RouteMetadata } from "../../../../../router/metadata";

const Screen = lazy(() => import("../../../../../views/administrator/models"));

export const Route = createFileRoute(
  "/_protected/(admin)/theme/$themeId/models",
)({
  component: RouteComponent,
  beforeLoad: ({ context }) => requireRoles(context.authSnapshot, ["Admin"]),
  params: {
    parse: validateAdminParams,
  },
  staticData: {
    routeKey: "theme-models",
    access: "admin",
    layout: "modern",
    container: "default",
    requiredRoles: ["Admin"],
    footer: false,
    mode: "list",
  } satisfies RouteMetadata,
});

function RouteComponent() {
  const hasChildMatch = useChildMatches({
    select: (matches) => matches.length > 0,
  });
  if (hasChildMatch) return <Outlet />;

  return (
    <Suspense fallback={<Loading loading={true} />}>
      <PageContainer
        pageContainerType={Route.options.staticData?.container}
        footer={Route.options.staticData?.footer}
      >
        <Screen />
      </PageContainer>
    </Suspense>
  );
}
